module.exports = __webpack_public_path__ + "media/refer_friend/invite-your-friends_400x180_@2x-4b10c195.png";